const initialState = {
    menuList: []
};


export const actionTypes = {
    menuList: '[menuList] Action'
}
  
export const MenuReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.menuList: {
            return {
                ...state,
                menuList: action.payload
            }
        }
        default: { 
            return state;
        }
    }
}

export const actions = {
    menuList: (menuList) => {
        return {
            type: actionTypes.menuList,
            payload: menuList
        }
    }
}